<template>
  <a-config-provider v-if="data.isLoaded" :locale="data.locale" :theme="theme">
    <login v-if="data.isLogin" /> <!--登录页面-->
    <main-view v-else /> <!--主页面-->
  </a-config-provider>

  <teleport to="body">
    <div class="loading" v-if="loading">
      <a-spin tip="处理中...">
      </a-spin>
    </div>
  </teleport>
</template>
<script setup lang="ts">
import Login from './views/login/Login.vue'
import MainView from '@views/main/index.vue'
import { reactive, ref } from 'vue'
import i18n from './locales/local'

const data = reactive({
  isLogin: false,
  isLoaded: false,
  locale: i18n.global.messages['zh-cn'].lang
})

// 路由守卫
$router.afterEach((to, from) => {
  const path = to.path.toLowerCase()
  data.isLoaded = true
  data.isLogin = path === '/login'
})

const loading = ref(false)
$util.setLoading(loading)

const theme = {
  token: {
    colorPrimary: '#2e9a92',
  }
}

</script> 
